import { render, staticRenderFns } from "./UrlInputWithUpload.vue?vue&type=template&id=f284dcd8&scoped=true&"
import script from "./UrlInputWithUpload.vue?vue&type=script&lang=js&"
export * from "./UrlInputWithUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f284dcd8",
  null
  
)

export default component.exports